import React, { useEffect } from 'react';
import { useTranslator } from '@front-activerse/common-components';
interface ExternalRedirectProps {
  to: string | { [key: string]: string };
}

const ExternalRedirect: React.FC<ExternalRedirectProps> = ({ to }) => {
  const { language } = useTranslator();

  useEffect(() => {
    if (typeof to === 'object') {
      window.location.href = to[language];
      return;
    }

    window.location.href = to;
  }, [to, language]);

  return null;
};

export default ExternalRedirect;
